// 获取昨天日期
function getYestodayDate () {
    let d = new Date()
    d.setTime(d.getTime() - 1000 * 60 * 60 * 24)
    let y = d.getFullYear()
    let m = d.getMonth() < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
    let dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
    let formatwdate = y + '-' + m + '-' + dd
    return formatwdate
}
// 获取上个月日期
function getPreMonthDate() {
    try {
        let d = new Date()
        let y = d.getFullYear()
        let m = d.getMonth() < 10 ? '0' + d.getMonth() : d.getMonth()
        let formatwdate = y + '-' + m
        return formatwdate
    } catch (e) {
        return ''
    }
}

export default{getYestodayDate, getPreMonthDate}
